import { compose, pure, withHandlers, withState } from 'recompose'
import { ValidatorHolder } from '../Container/validatorHolder'
import { IValidator } from '../types'
import FeaturedMediaModalSFC from './featuredMediaModal.sfc'
import { HandlerProps, IFeaturedMediaModalSFC, IOuterProps } from './types'

export const _handlers = {
  validateApply: (props: HandlerProps) => () => {
    if (!props.validator.current) {
      throw new Error(
        'Featured Media component container should add form validator'
      )
    }
    if (props.validator.current.validateAndApply()) {
      props.hideModal()
    }
  },
}

const enhancer = compose<IFeaturedMediaModalSFC, IOuterProps>(
  pure,
  withState('validator', 'setValidator', new ValidatorHolder<IValidator>()),
  withHandlers(_handlers)
)

export const FeaturedMediaModal = enhancer(FeaturedMediaModalSFC)
